import React, { createElement, useState, useRef } from 'react';
import { formatImage } from '@ifeng/public_method';
import Style from './index.module.scss';

interface VideoProps {
    content: {
        title: string;
        posterUrl: string;
        videoPlayUrl: string;
        showVideo: boolean;
    };
}

const Video: React.FC<VideoProps> = ({ content }) => {
    const { title, posterUrl, videoPlayUrl, showVideo } = content;
    const [startPlay, setStartPlay] = useState(false);
    const videoRef = useRef<HTMLVideoElement>();
    const poster = formatImage(posterUrl, 1008, 567) || posterUrl;

    return (
        <div className={Style.wrap}>
            {showVideo ? (
                <video
                    src={videoPlayUrl}
                    poster={poster}
                    controls={true}
                    ref={videoRef}
                    className={Style.video}
                ></video>
            ) : null}

            {!startPlay ? (
                <div
                    className={Style.posterWrap}
                    onClick={() => {
                        if (videoRef.current && showVideo) {
                            videoRef.current?.play().then(() => {
                                setStartPlay(true);
                            });
                        }
                    }}
                >
                    <img src={poster} alt={title} className={Style.poster} />
                    {showVideo ? (
                        <div className={Style.playIconWrap}>
                            <div className={Style.playIcon}></div>
                            <div className={Style.playIconText}></div>
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
};

export default Video;
